export default __webpack_public_path__ + "media/images/amenities/towel-08c75458276d9186d81cd0c5a24e9ad2.jpeg";